import { IStatsRange } from "../lib/backend/extractions.types.generated";
import { RANGE_TITLES, STATS_RANGES } from "../lib/consts";
import { ButtonMenu } from "./ButtonMenu";

type StatsRangeProps = {
    range: IStatsRange;
    local_storage_key?: string;
    setRange: (range: IStatsRange) => void;
}

export function initStatsRange(local_storage_key: string, default_range?: IStatsRange): IStatsRange {
    const range = localStorage.getItem(local_storage_key);
    if (range === null) {
        return default_range ?? "7d";
    }
    return range as IStatsRange;
}

export function StatsRange({ range, local_storage_key, setRange }: StatsRangeProps) {
    const handleRange = (range: IStatsRange) => {
        if (local_storage_key !== undefined) {
            localStorage.setItem(local_storage_key, range);
        }
        setRange(range);
    }

    return <div>
        <ButtonMenu
            title={RANGE_TITLES[range]}
            subtle={true}
            tiny={true}
            items={STATS_RANGES.map(r => ({
                title: RANGE_TITLES[r],
                onClick: () => handleRange(r),
                selected: range === r
            }))}
        />
    </div>
}